module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-02.8d7ac5b4.png";